import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Card,
  CardContent,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Alert,
  Chip,
  Divider
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
  GetApp as DownloadIcon,
  Security as SecurityIcon,
  Smartphone as SmartphoneIcon,
  CheckCircle as CheckIcon,
  Warning as WarningIcon,
  Info as InfoIcon
} from '@mui/icons-material';

const steps = [
  {
    label: 'Enable Unknown Sources',
    description: 'Allow installation from unknown sources in your Android settings',
    content: [
      'Open Settings on your Android device',
      'Go to Security & Privacy (or Security)',
      'Find "Install unknown apps" or "Unknown sources"',
      'Enable it for your browser (Chrome, Firefox, etc.)',
      'You may see a warning - this is normal for APK files'
    ]
  },
  {
    label: 'Download the APK',
    description: 'Download the attendance app APK file',
    content: [
      'Click the download button below or scan the QR code',
      'The APK file will be downloaded to your device',
      'File size is approximately 5-10 MB',
      'Ensure you have stable internet connection'
    ]
  },
  {
    label: 'Install the App',
    description: 'Install the downloaded APK file',
    content: [
      'Open your file manager or downloads folder',
      'Find the downloaded "base.apk" file',
      'Tap on the file to start installation',
      'Follow the installation prompts',
      'Grant necessary permissions when asked'
    ]
  },
  {
    label: 'Launch & Login',
    description: 'Open the app and start using it',
    content: [
      'Find the app icon on your home screen or app drawer',
      'Open the Attendance Monitoring app',
      'Use your faculty credentials to login',
      'Start marking attendance easily'
    ]
  }
];

export function AppDownload() {
  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
        Download Mobile App
      </Typography>

      {/* App Info Section */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={3} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ textAlign: 'center' }}>
              <img 
                src="/appqr.jpg" 
                alt="QR Code for App Download"
                style={{ 
                  maxWidth: '250px', 
                  width: '100%',
                  height: 'auto',
                  border: '2px solid #ddd',
                  borderRadius: '12px',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                }}
              />
              <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                Scan QR code with your phone camera to download
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                Attendance Monitoring App
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
                A lightweight mobile application designed specifically for faculty members to mark attendance quickly and efficiently.
              </Typography>
              
                            <Box sx={{ mb: 3 }}>                <Typography variant="h6" sx={{ mb: 2 }}>Features:</Typography>                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>                  <Chip label="Quick Login" size="small" variant="outlined" />                  <Chip label="Fast Attendance" size="small" variant="outlined" />                  <Chip label="Offline Support" size="small" variant="outlined" />                  <Chip label="Simple UI" size="small" variant="outlined" />                </Box>              </Box>

              <Button
                variant="contained"
                size="large"
                startIcon={<DownloadIcon />}
                href="https://www.mediafire.com/file/e093lheqgccdbi5/base.apk/file"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ mr: 2, mb: 2 }}
              >
                Download APK (5MB)
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

            {/* Important Notes */}      <Grid container spacing={3} sx={{ mb: 3 }}>        <Grid size={{ xs: 12, lg: 4 }}>          <Alert severity="info" icon={<InfoIcon />} sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>            <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>              <strong>Android Only:</strong> This app is currently available for Android devices only.            </Typography>          </Alert>        </Grid>        <Grid size={{ xs: 12, lg: 4 }}>          <Alert severity="warning" icon={<WarningIcon />} sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>            <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>              <strong>Security:</strong> Enable "Unknown Sources" only temporarily for installation.            </Typography>          </Alert>        </Grid>        <Grid size={{ xs: 12, lg: 4 }}>          <Alert severity="success" icon={<CheckIcon />} sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>            <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>              <strong>Safe:</strong> This app is developed by your institution and is completely safe.            </Typography>          </Alert>        </Grid>      </Grid>

      {/* Installation Steps */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
          Installation Guide
        </Typography>
        
        <Stepper orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.label} active={true} completed={false}>
              <StepLabel>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {step.label}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {step.description}
                </Typography>
              </StepLabel>
              <StepContent>
                <Box sx={{ pl: 2, pt: 1 }}>
                  {step.content.map((item, idx) => (
                    <Typography key={idx} variant="body2" sx={{ mb: 1, display: 'flex', alignItems: 'flex-start' }}>
                      <Box component="span" sx={{ mr: 1, color: 'primary.main' }}>•</Box>
                      {item}
                    </Typography>
                  ))}
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Paper>

      {/* Troubleshooting */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
          Troubleshooting
        </Typography>
        
                <Grid container spacing={3}>          <Grid size={{ xs: 12, lg: 6 }}>            <Card sx={{ height: '100%' }}>              <CardContent sx={{ p: 3 }}>                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>                  <SecurityIcon color="warning" sx={{ mr: 2, mt: 0.5 }} />                  <Typography variant="h6" sx={{ wordBreak: 'break-word' }}>                    Installation Blocked?                  </Typography>                </Box>                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>                  If Android blocks the installation:                </Typography>                <Box component="ul" sx={{ pl: 3, m: 0, '& li': { mb: 0.5, fontSize: '14px', lineHeight: 1.4 } }}>                  <li>Go to Settings → Security</li>                  <li>Enable "Unknown sources" or "Install unknown apps"</li>                  <li>Try installing again</li>                  <li>Disable "Unknown sources" after installation</li>                </Box>              </CardContent>            </Card>          </Grid>                    <Grid size={{ xs: 12, lg: 6 }}>            <Card sx={{ height: '100%' }}>              <CardContent sx={{ p: 3 }}>                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>                  <SmartphoneIcon color="info" sx={{ mr: 2, mt: 0.5 }} />                  <Typography variant="h6" sx={{ wordBreak: 'break-word' }}>                    App Won't Open?                  </Typography>                </Box>                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>                  If the app crashes or won't start:                </Typography>                <Box component="ul" sx={{ pl: 3, m: 0, '& li': { mb: 0.5, fontSize: '14px', lineHeight: 1.4 } }}>                  <li>Restart your device</li>                  <li>Clear app cache from Settings</li>                  <li>Reinstall the application</li>                  <li>Contact IT support if issues persist</li>                </Box>              </CardContent>            </Card>          </Grid>        </Grid>
      </Paper>

      {/* App Requirements */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
          System Requirements
        </Typography>
        
                <Grid container spacing={4}>          <Grid size={{ xs: 12, md: 6 }}>            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>              Minimum Requirements:            </Typography>            <Box component="ul" sx={{ pl: 3, m: 0, '& li': { mb: 1, fontSize: '14px', lineHeight: 1.5 } }}>              <li>Android 5.0 (API level 21) or higher</li>              <li>50 MB free storage space</li>              <li>Internet connection for sync</li>              <li>Camera permission (for QR scanning)</li>            </Box>          </Grid>                    <Grid size={{ xs: 12, md: 6 }}>            <Typography variant="h6" sx={{ mb: 2, color: 'success.main' }}>              Recommended:            </Typography>            <Box component="ul" sx={{ pl: 3, m: 0, '& li': { mb: 1, fontSize: '14px', lineHeight: 1.5 } }}>              <li>Android 8.0 or higher</li>              <li>2GB RAM or more</li>              <li>WiFi or 4G connection</li>              <li>Updated web browser</li>            </Box>          </Grid>        </Grid>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Need help? Contact your IT administrator or technical support team.
          </Typography>
          <Button
            variant="outlined"
            href="mailto:support@yourinstitution.edu"
            startIcon={<InfoIcon />}
          >
            Contact Support
          </Button>
        </Box>
      </Paper>
    </Box>
  );
} 